import axios from 'axios';
const md5 = require('md5');
const apis = require('./apis');

class Request {

  constructor() {
    this.axios = axios
    this.apis = apis
    this.requestInterCeptors()
    this.responseInterCeptors()
  }

  requestInterCeptors() {
    this.axios.interceptors.request.use((config) => {
      if (config.sign) {
        config.headers = Object.assign(this.createSign(config.data), config.headers)
      }
      if(config.headers) {
        if (!config.headers.appcode) {
          config.headers.appcode = 'com.rjhy.uranus'
        }
      } else {
        config.headers = {
          appcode : 'com.rjhy.uranus'
        }
      }
      // console.log('config', config )
      return config;
    }, function (error) {
      return Promise.reject(error);
    })
  }

  responseInterCeptors() {
    this.axios.interceptors.response.use(response => {
      // console.log(response.data, '========response.data')
      if (response.data.data) {
        if (response.data.totalCount) return response.data
        return response.data.data
      }
      return response.data
    })
  }

  createSign(params) {
    let valueArr = [];
    const signStr = 'sjdxfnqogbzoun13d971ckh8p';
    if (params) {
      const sortedObjKeys = Object.keys(params).sort();
      for (let index in sortedObjKeys) {
        valueArr.push(params[sortedObjKeys[index]]);
      }
    }
    let timestamp = new Date().getTime();
    const sign = md5(signStr + valueArr.join('') + timestamp);
    let headers = {
      signature: sign,
      timestamp: timestamp
    };
    return headers;
  }

  get(opt) {
    const {url, sign = true, params = {}, headers = {}} = opt
    return this._request({
      url,
      method: 'get',
      sign,
      params,
      headers
    })
  }

  _get (url, params, sign = false, extraHeaders = {}) {
    let headers = {}
    if(sign) {
      headers = this.createSign(params)
    }
    headers = Object.assign(headers, extraHeaders)
    Object.keys(params)
      .forEach((key, idx) => {
        if(idx === 0) url += `?${key}=${params[key]}`
        else url += `&${key}=${params[key]}`
      })
    return this._request({
      url,
      method: 'GET',
      headers
    })
  }
  
  post(opt) {
    const {url, sign = true, params = {}, headers = {}} = opt
    return this._request({
      url,
      method: 'post',
      sign,
      data: params,
      headers
    })
  }
  _request(opt) {
    const { method } = opt
    let header = { }
    if (method === 'get') {
      header = { 'Accept': 'application/json' }
    } else {
      header = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }
    opt.headers = Object.assign(header, opt.headers)
    return this.axios.request(opt)
  }
}


export const rjhySms = axios.create({
  baseURL: apis.rjhySms,
  timeout: 50000,
  headers: {}
})

export const rjhyUser = axios.create({
  baseURL: apis.rjhyUser,
  timeout: 50000,
  headers: {}
})

export const rjhyCircle = axios.create({
  baseURL: apis.rjhyCircle,
  timeout: 50000,
  headers: {}
})

export const request =  new Request()

const services = [rjhySms, rjhyUser, rjhyCircle]

services.forEach(service => {
  service.interceptors.request.use((config) => {
    if(config.headers) {
      config.headers.appcode = 'com.rjhy.uranus'
    } else {
      config.headers = {
        appcode : 'com.rjhy.uranus'
      }
    }
    return config;
  }, function (error) {
    return Promise.reject(error);
  })
  
  service.interceptors.response.use(response => {
    if (response.status == 200) {
      return response.data;
    }
  }, error => Promise.reject(error))
})
